import { z } from 'zod';
import { createSortablePaginationSchema } from '../shared/index.js';
/**
 * Schema for searching followers (subscribers) of a government with pagination.
 * The `search` term performs a case-insensitive partial match against the
 * follower's user email, first name, or last name.
 */
export const FOLLOWER_ORDER_BY_FIELDS = ['createdAt', 'email', 'firstName', 'lastName'];
export const followerSearchSchema = createSortablePaginationSchema(FOLLOWER_ORDER_BY_FIELDS).extend({
    search: z.string().optional(),
});
/**
 * Schema for searching invites for a government with pagination.
 * `search` matches against the invited email (case-insensitive). `status`
 * narrows results to pending or accepted invites.
 */
export const INVITE_ORDER_BY_FIELDS = ['acceptedAt', 'createdAt', 'email'];
export const inviteSearchSchema = createSortablePaginationSchema(INVITE_ORDER_BY_FIELDS).extend({
    search: z.string().optional(),
    status: z.enum(['pending', 'accepted']).optional(),
});
const emailSchema = z.email().trim().toLowerCase();
/**
 * Schema for bulk-creating subscriber invites. Caps requests at 100 emails to
 * keep the per-request transaction bounded.
 */
export const bulkInviteCreateSchema = z.object({
    emails: z.array(emailSchema).min(1).max(100),
});
